import "./dashboard-sections.css";
import DashboardCard from "./DashboardCard";
import useTranslator from "../../../hooks/useTranslator";
import { formatNumber } from "../../../helpers/Utils";

const EvapBox = ({ label, value, unit, isLoading = false }) => (
  <div className="db-evap-box">
    <div className="db-evap-label">{label}</div>
    <div className="db-evap-value neutral">
      {isLoading
        ? <span className="db-shimmer" style={{ height: 24, width: 60, display: "block" }} />
        : <>{value ?? "—"}{unit && <span className="db-metric-unit"> {unit}</span>}</>
      }
    </div>
  </div>
);

const RunningTotalsExtra = ({ data = {}, isLoading = false }) => {
  const { _t } = useTranslator();
  const prcsMetrics   = data?.processing_metrics ?? {};
  const packingMetrics = data?.packing_analytics ?? {};

  return (
    <div className="rte-wrapper">

      <DashboardCard title={_t("processing_text_db", "Processing")}>
        <div className="db-evap-row">
          <EvapBox label={_t("total_accepted_kg_db", "TOTAL ACCEPTED KG")}     value={formatNumber(prcsMetrics?.total_accepted_in_processing) ?? 0} unit="kg" isLoading={isLoading} />
          <EvapBox label={_t("total_cases_processed_db", "TOTAL CASES PROCESSED")} value={formatNumber(prcsMetrics?.total_cases_processed )?? 0}                  isLoading={isLoading} />
          <EvapBox label={_t("gas_liters_db", "GAS LITERS")}            value={formatNumber(prcsMetrics?.total_gas_consumed_ltr) ?? 0}        unit="L"  isLoading={isLoading} />
          <EvapBox label={_t("gas_costing_db", "GAS COSTING")}           value={prcsMetrics?.total_gas_cost ? `$${formatNumber(prcsMetrics.total_gas_cost)}` : "0"} isLoading={isLoading} />
        </div>
      </DashboardCard>

      <DashboardCard title={_t("packing_db", "Packing")}>
        <div className="db-evap-row">
          <EvapBox label={_t("prime_cheeks_packed_db", "PRIME CHEEKS PACKED")}      value={formatNumber(packingMetrics?.prime_cheeks_packed_kg) ?? 0}      unit="kg" isLoading={isLoading} />
          <EvapBox label={_t("prime_strips_packed_db", "PRIME STRIPS PACKED")}      value={formatNumber(packingMetrics?.prime_strips_packed_kg) ?? 0}      unit="kg" isLoading={isLoading} />
          <EvapBox label={_t("total_boxes_packed_prime_db", "TOTAL BOXES PACKED PRIME")} value={formatNumber(packingMetrics?.total_prime_packed_boxes) ?? 0}              isLoading={isLoading} />
        </div>
        <div className="db-evap-row" style={{ borderTop: "1px solid #f0f1f3", paddingTop: 12 }}>
          <EvapBox label={_t("brokering_kg_prime_db", "BROKERING KG PRIME")}       value={formatNumber(packingMetrics?.total_prime_kg_from_brokerage) ?? 0}  unit="kg" isLoading={isLoading} />
          <EvapBox label={_t("brokering_2nd_and_pieces_db", "BROKERING 2ND & PIECES")}   value={`${formatNumber(packingMetrics?.total_second_kg_from_brokerage) ?? 0} & ${packingMetrics?.total_pieces_kg_from_brokerage ?? 0}`} unit="kg" isLoading={isLoading} />
          <EvapBox label={_t("pasting_boxes_brok_pack_db", "PASTING BOXES (BROK+PACK)")} value={formatNumber(packingMetrics?.total_pasted_boxes_packed) ?? 0}              isLoading={isLoading} />
        </div>
      </DashboardCard>

    </div>
  );
};

export default RunningTotalsExtra;
